// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  origin: 'https://apapi-dev.radiantdelivers.com/api/v1/',
  mock: false,
  version: require( '../../config.json' ).version,
  gtagId: '', // leave this blank,
  maintenanceUrl: 'https://rgl-static-cdn.s3.amazonaws.com/maintenance_dev.json',
  lambdaApi: 'https://bva8wl0e72.execute-api.us-east-1.amazonaws.com/Stage/',
  localLambdaApi: 'http://localhost:3000/',
  portal: 'agent',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
